/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import common from './commonActions'
import auth from "./authActions";
import deliveryOrder from './deliveryOrderActions'
import deliverySheet from './deliverySheetAction'
import account from './accountAction'
import app from './appAction'
import merchant from "./merchantAction";
import kpiAction from "./kpiAction";
import operationActions from "./operationActions";
import socketAction from "./socketAction";
import helpDeskAction from "./helpDeskAction";
import notificationAction from "./notificationAction";

export default {
  ...auth,
  ...deliveryOrder,
  ...common,
  ...account,
  ...deliverySheet,
  ...app,
  ...merchant,
  ...kpiAction,
  ...operationActions,
  ...socketAction,
  ...helpDeskAction,
  ...notificationAction,
};
